module.exports = __webpack_public_path__ + "img/06.f768092c.png";